import styled from 'styled-components';

export const StatusIcon = styled.span`
    &.status-missing {
        color: ${({ theme }) => theme.colors.icon.missing};
    }
    &.status-unsaved {
        color: ${({ theme }) => theme.colors.icon.unsaved};
    }
    &.status-saved {
        color: ${({ theme }) => theme.colors.icon.saved};
        font-size: 1.1rem;
    }
    &.status-edited {
        color: ${({ theme }) => theme.colors.icon.edited};
    }
    &.status-completed {
        color: ${({ theme }) => theme.colors.icon.completed};
    }
    &.status-approved {
        color: ${({ theme }) => theme.colors.icon.approved};
    }
    &.status-tankers-event-mismatch {
        color: ${({ theme }) => theme.colors.icon.tankersMismatch};
    }
    &.status-incomplete {
        color: ${({ theme }) => theme.colors.icon.incomplete};
    }
`;

export const StatusNumberIcon = styled.span`
    &.status-missing {
        background: ${({ theme }) => theme.colors.icon.missing};
        color: ${({ theme }) => theme.colors.text.white};
        height: 1.1rem;
        width: 1.1rem;
        border-radius: 50%;
        display: flex;
        font-size: 0.65rem;
        text-align: center;
        align-items: center;
        justify-content: center;
    }
`;
